import { render, staticRenderFns } from "./PrintProvider.vue?vue&type=template&id=23b32fa2&"
import script from "./PrintProvider.vue?vue&type=script&lang=js&"
export * from "./PrintProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports